/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Allfiles1Inputs */

const id_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua file`)
};

const ms_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua fail`)
};

const da_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle filer`)
};

const de_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Dateien`)
};

const en_us2_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All files`)
};

const es_es2_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los archivos`)
};

const es_mx2_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los archivos`)
};

const fil_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lahat ng file`)
};

const fr_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les fichiers`)
};

const it_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i file`)
};

const hu_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minden fájl`)
};

const nl_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle bestanden`)
};

const no_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle filer`)
};

const pl_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie pliki`)
};

const pt_br2_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os arquivos`)
};

const pt_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os ficheiros`)
};

const ro_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toate fișierele`)
};

const fi_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaikki tiedostot`)
};

const sv_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla filer`)
};

const vi_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả tệp`)
};

const tr_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm dosyalar`)
};

const cs_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všechny soubory`)
};

const bg_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всички файлове`)
};

const ru_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все файлы`)
};

const uk_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усі файли`)
};

const ar_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل الملفات`)
};

const hi_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी फ़ाइलें`)
};

const th_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไฟล์ทั้งหมด`)
};

const ja_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのファイル`)
};

const zh_cn2_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有文件`)
};

const zh_hant1_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有檔案`)
};

const ko_builds_comparison_allfiles1 = /** @type {(inputs: Builds_Comparison_Allfiles1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 파일`)
};

/**
* | output |
* | --- |
* | "All files" |
*
* @param {Builds_Comparison_Allfiles1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_allfiles1 = /** @type {((inputs?: Builds_Comparison_Allfiles1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Allfiles1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_allfiles1(inputs)
	if (locale === "ms") return ms_builds_comparison_allfiles1(inputs)
	if (locale === "da") return da_builds_comparison_allfiles1(inputs)
	if (locale === "de") return de_builds_comparison_allfiles1(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_allfiles1(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_allfiles1(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_allfiles1(inputs)
	if (locale === "fil") return fil_builds_comparison_allfiles1(inputs)
	if (locale === "fr") return fr_builds_comparison_allfiles1(inputs)
	if (locale === "it") return it_builds_comparison_allfiles1(inputs)
	if (locale === "hu") return hu_builds_comparison_allfiles1(inputs)
	if (locale === "nl") return nl_builds_comparison_allfiles1(inputs)
	if (locale === "no") return no_builds_comparison_allfiles1(inputs)
	if (locale === "pl") return pl_builds_comparison_allfiles1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_allfiles1(inputs)
	if (locale === "pt") return pt_builds_comparison_allfiles1(inputs)
	if (locale === "ro") return ro_builds_comparison_allfiles1(inputs)
	if (locale === "fi") return fi_builds_comparison_allfiles1(inputs)
	if (locale === "sv") return sv_builds_comparison_allfiles1(inputs)
	if (locale === "vi") return vi_builds_comparison_allfiles1(inputs)
	if (locale === "tr") return tr_builds_comparison_allfiles1(inputs)
	if (locale === "cs") return cs_builds_comparison_allfiles1(inputs)
	if (locale === "bg") return bg_builds_comparison_allfiles1(inputs)
	if (locale === "ru") return ru_builds_comparison_allfiles1(inputs)
	if (locale === "uk") return uk_builds_comparison_allfiles1(inputs)
	if (locale === "ar") return ar_builds_comparison_allfiles1(inputs)
	if (locale === "hi") return hi_builds_comparison_allfiles1(inputs)
	if (locale === "th") return th_builds_comparison_allfiles1(inputs)
	if (locale === "ja") return ja_builds_comparison_allfiles1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_allfiles1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_allfiles1(inputs)
	return ko_builds_comparison_allfiles1(inputs)
});
export { builds_comparison_allfiles1 as "builds.comparison.allFiles" }